import { Component, OnDestroy, OnInit, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from '../../../../app.service';
import { ModalDialogueService } from '../../../../shared/components/modal-dialogue/modal-dialogue.service';
import { LoadingSpinnerService } from '../../../../shared/services/loading-spinner.service';
import { ToasterService } from '../../../../shared/services/toaster.service';
import { CheckpointService } from '../../checkpoints/checkpoint.service';
import { JobsService } from '../../jobs/jobs.service';
import { DomSanitizer } from '@angular/platform-browser';
import { isLargeScreen } from '../../../../../global.variable';

@Component({
  selector: 'gtapp-add-sop',
  standalone: false,
  templateUrl: './add-sop.component.html',
  styleUrl: './add-sop.component.scss',
})
export class AddSopComponent implements OnInit, OnDestroy {
  uploadFile: any;
  fileUploadError: string = '';

  assigneeList: any = [];
  selectedAssigneeIds: any = [];
  assigneeSearchList: any = [];

  sopAssigneeRows: number = 2;
  sopAssigneePrevious: number = 0;
  sopAssigneePageNum: number = 1;
  sopAssigneeTotalPages: number = 0;
  sopAssigneeTotalCount: number = 0;

  currentStep: number = 1;
  addSOPPressed: boolean = false;
  pdfFileUrl: any;
  isLargeView = isLargeScreen;
  ngOnDestroy(): void {}
  ngOnInit(): void {}
  constructor(
    private jobService: JobsService,
    private dialogService: ModalDialogueService,
    private spinnerService: LoadingSpinnerService,
    private viewContainerRef: ViewContainerRef,
    private appService: AppService,
    private toasterService: ToasterService,
    private router: Router,
    private sanitizer: DomSanitizer,
  ) {}
  async fileCheck(fileExtension: string, fileSize: number) {
    let fileLimit: number = 1024 * 1024 * 8; // 8MB
    return new Promise((resolve) => {
      if (!['pdf'].includes(fileExtension?.toLowerCase())) {
        this.fileUploadError = 'Unsupported file format';
        resolve(false);
      } else if (fileSize > fileLimit) {
        this.fileUploadError = 'File Too Large ' + fileSize + ' / ' + fileLimit;
        resolve(false);
      } else {
        this.fileUploadError = '';
        resolve(true);
      }
    });
  }
  async handleFileInput(event: any) {
    let file = event?.target?.files.item(0);
    let fileSize: number = file.size;
    let fileName: string = file.name;
    let fileExtension: string = fileName.split('.').pop() || '';
    let fileCheck = await this.fileCheck(fileExtension, fileSize);
    if (fileCheck) {
      this.uploadFile = event?.target?.files.item(0);
      const fileURL = URL.createObjectURL(file);
      this.pdfFileUrl = this.sanitizer.bypassSecurityTrustResourceUrl(fileURL);
    }
  }
  selectFile() {
    var button: any = document.getElementById('fileInput');
    button.click();
  }
  getAssignees() {
    let params: any = {};
    if (this.sopAssigneeRows) {
      params['rows'] = this.sopAssigneeRows;
    }
    if (this.sopAssigneePrevious) {
      params['previous'] = this.sopAssigneePrevious;
    }

    this.spinnerService.show();
    this.jobService.getAssignees(params).subscribe((response: any) => {
      if (response['status'] == 'success') {
        this.assigneeList.push(...response?.data);

        this.sopAssigneeTotalCount = response?.total_count;
        this.sopAssigneeTotalPages = Math.ceil(
          this.sopAssigneeTotalCount / this.sopAssigneeRows,
        );
      } else {
      }
      this.spinnerService.hide();
    });
  }

  selectDeselectSingleAssignee(assigneeData: any) {
    const id = assigneeData?.id;
    const index = this.selectedAssigneeIds.indexOf(id);

    if (index > -1) {
      this.selectedAssigneeIds.splice(index, 1);
    } else {
      this.selectedAssigneeIds.push(id);
      const indexInAssigneeList = this.assigneeList?.findIndex(
        (item: any) => item?.id == id,
      );
      if (indexInAssigneeList < 0) {
        this.assigneeList.push(assigneeData);
      }
    }
  }

  searchAssignee(event?: any) {
    if (event.target.value?.length > 2) {
      let params: any = { full_name: event.target.value };
      this.jobService.getAssignees(params).subscribe((response: any) => {
        if (response['status'] == 'success') {
          this.assigneeSearchList = response?.data?.filter(
            (assignee: any) =>
              !this.selectedAssigneeIds?.includes(assignee?.id),
          );
        } else {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response['message'],
          });
        }
      });
    }
  }
  onLoadMoreAssignees() {
    this.sopAssigneePrevious = this.sopAssigneePrevious + this.sopAssigneeRows;

    this.getAssignees();
    setTimeout(() => {
      const table = document.querySelector('#assigneeList');
      if (table) {
        table.scrollTo({ top: table.scrollHeight, behavior: 'smooth' });
      }
    }, 100);
  }
  onAddSOP() {
    this.spinnerService.show('Uploading File');
    let fileData: FormData = new FormData();

    fileData.append('file', this.uploadFile);
    fileData.append('user_ids', JSON.stringify(this.selectedAssigneeIds));

    this.appService
      .formDataApi('sop', fileData, false, {}, 'POST', false)
      .then((resp: any) => {
        if (resp?.status === 'success') {
          this.toasterService.setMessage({
            successMessage: resp['message'],
            errorMessage: '',
          });
          this.router.navigate(['/sop']);
        } else {
          this.addSOPPressed = false;
          this.spinnerService.hide();
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: resp['message'],
          });
        }
      });
  }
}
